// Mobile drawer (hamburger). HTML needs #toggle and .l-header-nav.
// 状態クラス: #toggle.toggle_active, nav.is_open, body.drawer_open
export function initDrawer() {
  const toggle = document.getElementById('toggle');
  const nav = document.querySelector('.l-header-nav');
  const header = document.querySelector('.l-header');
  if (!toggle || !nav) return;

  const close = () => {
    toggle.classList.remove('toggle_active');
    nav.classList.remove('is_open');
    nav.classList.add('is_close');
    header?.classList.remove('is_open');
    document.body.classList.remove('drawer_open');
  };

  const open = () => {
    toggle.classList.add('toggle_active');
    nav.classList.add('is_open');
    nav.classList.remove('is_close');
    header?.classList.add('is_open');
    document.body.classList.add('drawer_open');
  };

  toggle.addEventListener('click', () => {
    toggle.classList.contains('toggle_active') ? close() : open();
  });

  nav.addEventListener('click', (e) => {
    if (e.target === nav && nav.classList.contains('is_open')) close();
  });

  nav.querySelectorAll('a').forEach((anchor) => {
    anchor.addEventListener('click', () => {
      if (toggle.offsetParent !== null) close();
    });
  });
}
